<script>
export default {}
</script>
<template>
  <v-card-text class="pa-4"><slot></slot></v-card-text>
</template>
